import { ChevronRight, FileText } from 'lucide-react';
import { signedDate } from './helper';

const Documents = ({ consentForms, onView }) => (
  <div className="mb-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
    {consentForms.map((consentForm) => {
      const { id, attributes: { title } } = consentForm;
      const signedOn = signedDate(consentForm.attributes);
      const meta = [signedOn && `Signed ${signedOn}`, 'PDF'].filter(Boolean).join(' · ');

      return (
        <button
          key={id}
          type="button"
          onClick={() => onView(consentForm)}
          className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white p-3.5 text-left transition-colors hover:border-secondary-300 hover:bg-secondary-50"
        >
          <span className="flex h-11 w-11 shrink-0 flex-col items-center justify-center gap-0.5 rounded-lg border border-gray-200 bg-gray-50">
            <FileText size={16} className="text-secondary-300" />
            <span className="text-[8px] font-bold leading-none text-red-500">PDF</span>
          </span>

          <span className="min-w-0 flex-1">
            <span className="block truncate text-sm font-bold text-secondary-900">{title}</span>
            <span className="mt-0.5 block text-xs text-secondary-400">{meta}</span>
          </span>

          <ChevronRight size={18} className="shrink-0 text-secondary-300" />
        </button>
      )
    })}
  </div>
);

export default Documents;
